import type { ReactElement, ReactNode } from 'react';
import svg from '!!raw-loader!@search/metro/build/maps/smr.svg';

export default ({ children }: { children: (svg: ReactNode) => ReactElement }): ReactElement => {
    return children(svg);
};
